<template>
  <div>
    <h4 class="text-center">Pesquisar Frentes de Trabalho</h4>

    <img
      src="@/assets/images/search.png"
      alt="search"
      class="d-none d-lg-block w-100 mb-5"
    />

    <div class="form-group row mb-1">
      <div class="col-lg-3 mb-1 mb-lg-0">
        <label>Id</label>
        <input
          type="text"
          class="form-control form-control-sm"
          v-model="work_front_filters.id"
        />
      </div>
      <div class="col-lg-9 mb-1 mb-lg-0">
        <label>Nome</label>
        <input
          type="text"
          class="form-control form-control-sm"
          v-model="work_front_filters.name"
        />
      </div>
    </div>

    <div
      class="d-flex flex-column flex-lg-row align-items-center justify-content-lg-between"
    >
      <button class="btn btn-success mb-3 mb-lg-0" @click="onFilter">
        <font-awesome-icon :icon="['fas', 'filter']"></font-awesome-icon>
        Filtrar
      </button>

      <button class="btn btn-secondary" @click="clearFilter">
        <font-awesome-icon :icon="['fas', 'broom']"></font-awesome-icon>
        Resetar
      </button>
    </div>
  </div>
</template>

<script>
  import { ref, onBeforeMount } from 'vue'
  import useWorkFront from '@/modules/WorkFront.js'

  export default {
    name: 'WorkFrontFilter',
    setup() {
      const { listWorkFront } = useWorkFront()
      const work_front_filters = ref({})

      const clearFilter = () => {
        work_front_filters.value = {}
      }

      const onFilter = () => {
        // filtro aplicado via work_front_filters
      }

      onBeforeMount(() => {
        clearFilter()
      })

      return {
        work_front_filters,
        clearFilter,
        onFilter,
      }
    },
  }
</script>
